<template>
  <v-app>
    <div id="container">
      <create-business-location-component
          :siteId="this.siteId"
          :isUpdateMode="true"
      ></create-business-location-component>
    </div>
  </v-app>
</template>

<script>
import CreateBusinessLocationComponent from "../../../components/b2b/hyundai/CreateBusinessLocationComponent";
export default {
  name: "hyundaiDeleteBusinessLocation",
  components: {CreateBusinessLocationComponent},
  props: {
    siteId: {
      type: Number,
      default() { return -1; }
    }
  }
}
</script>

<style scoped>
#container {
  background: #D2D2D2;
  font-family: HDharmony, sans-serif;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}
</style>
